import { persistReducer } from 'redux-persist'
import { Action } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  GetFreeMailTableData: '[GetFreeMailTableData] Action',
  SetFreeMailData: '[SetFreeMailData] Action',
  GetFreeMailTranslateData: '[GetFreeMailTranslateData] Action',
}

const initialFreeMailState: IFreeMailState = {
  freeMailColumnList: [],
  freeMailColumnValues: [],
  freeMailDefinitions: [],
  freeMailColumnNames: [],
  freeMailDataTypes: [],
  freeMailDe: [],
  freeMailEn: [],

  freeMailsOptions: []
}

export interface IFreeMailState {
  freeMailColumnValues: [],
  freeMailColumnList: [],
  freeMailDefinitions: []
  freeMailColumnNames: [],
  freeMailDataTypes: [],
  freeMailDe: [],
  freeMailEn: [],

  freeMailsOptions: []
}

export const reducer = persistReducer(
  { storage, key: 'portal-FreeMail', whitelist:  [ ] },
  (state: IFreeMailState = initialFreeMailState, action: any) => {
    switch (action.type) {
      case actionTypes.GetFreeMailTableData: {
        const freeMailColumnValues = JSON.parse(action.payload.data.freeMails);
        let headers = JSON.parse(action.payload.data.headers);
        let freeMailDefinitions = JSON.parse(action.payload.data.definitions);
        let freeMailColumnNames = action.payload.data.columnNames;
        let freeMailDataTypes = action.payload.data.dataTypes;
        let freeMailColumnList: any = [];
       
        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          freeMailColumnList.push(newElement[0]);
        });
        return { ...state, freeMailColumnList, freeMailColumnValues, freeMailDefinitions, freeMailDataTypes , freeMailColumnNames};
      }
    
      case actionTypes.SetFreeMailData: {
        const freeMailColumnValues = action.payload.data;
        return { ...state, freeMailColumnValues };
      }

      case actionTypes.GetFreeMailTranslateData: {
        const freeMailDe = JSON.parse(action.payload.data.de);
        const freeMailEn = JSON.parse(action.payload.data.en);
        return { ...state, freeMailDe, freeMailEn };
      }
      
      default:
        return state
    }
  }
)

export const actions = {
  getFreeMailTableData: (data: any) => ({ type: actionTypes.GetFreeMailTableData, payload: { data } }),
  getTranslateData: (data: any) => ({ type: actionTypes.GetFreeMailTranslateData, payload: { data } }),
  setFreeMailData: (data: any) => ({ type: actionTypes.SetFreeMailData, payload: { data } }),
  store: () => ({ type: "def" }),
}

export function* saga() {

}
